<template>
	<Insurance title="Secondary" :insurance="secondary" :is_primary="false" />
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex"
import TabExtension from "../TabExtension"
import Insurance from './Insurance'

export default TabExtension.extend({
	name: "secondary-insurance",
	components: {
		Insurance
	},
	computed: {
        ...mapGetters('insurances', ['getSecondaryInsurance']),
        secondary() {
            return this.getSecondaryInsurance()
        },
	},
	methods: {
		...mapActions("insurances", ["getInsurancesForCurrentPatient"]),
		async loadForPatient(patient) {
        	await this.getInsurancesForCurrentPatient()
		}
    }
})
</script>